import VerifyCodeOnly from './VerifyCodeOnly'

export default VerifyCodeOnly
